const formatFileSize = (bytes) => {
  if (!Number.isFinite(bytes) || bytes <= 0) return null;

  const units = ['t', 'kt', 'Mt', 'Gt'];
  const unitIndex = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / 1024 ** unitIndex;
  const maximumFractionDigits = value >= 10 || unitIndex === 0 ? 0 : 1;

  return `${value.toLocaleString('fi-FI', { maximumFractionDigits })} ${units[unitIndex]}`;
};

const getFileSize = async (fileUrl) => {
  const headResponse = await fetch(fileUrl, { method: 'HEAD' });
  const headSize = Number(headResponse.headers.get('content-length'));

  if (headResponse.ok && headSize > 0) return headSize;

  const rangeResponse = await fetch(fileUrl, {
    headers: { Range: 'bytes=0-0' },
  });
  const contentRange = rangeResponse.headers.get('content-range');
  const rangeSize = Number(contentRange?.split('/').pop());

  return rangeResponse.ok ? rangeSize : null;
};

const updateFileSize = async (fileItem) => {
  const fileUrl = fileItem.dataset.fileUrl;
  const sizeElement = fileItem.querySelector('[data-file-size]');

  if (!fileUrl || !sizeElement) return;

  try {
    const formattedSize = formatFileSize(await getFileSize(fileUrl));

    if (formattedSize) {
      sizeElement.textContent = formattedSize;
    }
  } catch {
    // The file link and its download remain usable if the CDN blocks HEAD requests.
  }
};

const sortAndGroupMaterialLists = (listsContainer) => {
  if (listsContainer.dataset.materialListsInitialized === 'true') return;

  const materialLists = [...listsContainer.querySelectorAll(':scope > [data-aineistolistaus-list]')];
  const collator = new Intl.Collator('fi-FI', { sensitivity: 'base' });

  materialLists.sort((firstList, secondList) => {
    const groupComparison = collator.compare(firstList.dataset.groupHeading, secondList.dataset.groupHeading);
    const orderComparison = Number(firstList.dataset.listOrder) - Number(secondList.dataset.listOrder);

    return groupComparison || orderComparison || collator.compare(firstList.dataset.listHeading, secondList.dataset.listHeading);
  });

  listsContainer.replaceChildren();

  materialLists.forEach((materialList) => {
    const groupHeading = materialList.dataset.groupHeading;
    const previousGroup = listsContainer.lastElementChild;
    const group =
      previousGroup?.dataset.groupHeading === groupHeading
        ? previousGroup
        : createMaterialGroup(groupHeading);

    materialList.querySelector('[data-aineistolistaus-group-heading]')?.setAttribute('hidden', '');
    group.querySelector('[data-aineistolistaus-group-lists]').append(materialList);
    listsContainer.append(group);
  });

  listsContainer.dataset.materialListsInitialized = 'true';
};

const createMaterialGroup = (heading) => {
  const group = document.createElement('section');
  const title = document.createElement('h3');
  const lists = document.createElement('div');

  group.className = 'aineistolistaus__group';
  group.dataset.groupHeading = heading;
  title.className = 'aineistolistaus__group-heading';
  title.textContent = heading;
  lists.className = 'aineistolistaus__group-lists';
  lists.dataset.aineistolistausGroupLists = '';

  group.append(title, lists);

  return group;
};

const initializeCollapsibleLists = () => {
  document.querySelectorAll('[data-aineistolistaus-list-toggle]').forEach((toggle) => {
    if (toggle.dataset.collapsibleInitialized === 'true') return;

    const files = document.getElementById(toggle.getAttribute('aria-controls'));

    if (!files) return;

    toggle.dataset.collapsibleInitialized = 'true';
    toggle.addEventListener('click', () => {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      toggle.setAttribute('aria-expanded', String(!isExpanded));
      files.hidden = isExpanded;
    });
  });
};

const initializeMaterialListings = () => {
  document.querySelectorAll('[data-aineistolistaus-lists]').forEach(sortAndGroupMaterialLists);
  initializeCollapsibleLists();

  document.querySelectorAll('[data-aineistolistaus-file]').forEach((fileItem) => {
    if (fileItem.dataset.fileSizeInitialized === 'true') return;

    fileItem.dataset.fileSizeInitialized = 'true';
    updateFileSize(fileItem);
  });
};

initializeMaterialListings();
document.addEventListener('shopify:section:load', initializeMaterialListings);
